module.exports = __webpack_public_path__ + "assets/img/arrow_right.87b4ff3f.svg";